/**
 * @generated SignedSource<<9236feeee4bbf4766eae955bec7fd579>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type OrganizationMembershipKind = "ADMIN" | "EDITOR" | "OWNER" | "READER";
import { FragmentRefs } from "relay-runtime";
export type OrganizationUsersFragment$data = {
  readonly id: string;
  readonly users: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly kind: OrganizationMembershipKind;
        readonly user: {
          readonly displayName: string;
          readonly id: string;
          readonly username: string;
          readonly " $fragmentSpreads": FragmentRefs<"EntityProfilePicFragment">;
        };
        readonly viewerCanDelete: boolean;
      };
    }>;
  };
  readonly viewerCanEdit: boolean;
  readonly viewerCanTransferOwnership: boolean;
  readonly " $fragmentType": "OrganizationUsersFragment";
};
export type OrganizationUsersFragment$key = {
  readonly " $data"?: OrganizationUsersFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"OrganizationUsersFragment">;
};

import OrganizationUsersFragmentPaginationQuery_graphql from './OrganizationUsersFragmentPaginationQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "users"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "count"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cursor"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": (v0/*:: as any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "count",
          "cursor": "cursor"
        },
        "backward": null,
        "path": (v0/*:: as any*/)
      },
      "fragmentPathInResult": [
        "node"
      ],
      "operation": OrganizationUsersFragmentPaginationQuery_graphql,
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "OrganizationUsersFragment",
  "selections": [
    (v1/*:: as any*/),
    {
      "alias": "viewerCanEdit",
      "args": [
        {
          "kind": "Literal",
          "name": "action",
          "value": "UPDATE_ORGANIZATION_MEMBERSHIP"
        }
      ],
      "kind": "ScalarField",
      "name": "viewerCan",
      "storageKey": "viewerCan(action:\"UPDATE_ORGANIZATION_MEMBERSHIP\")"
    },
    {
      "alias": "viewerCanTransferOwnership",
      "args": [
        {
          "kind": "Literal",
          "name": "action",
          "value": "TRANSFER_ORGANIZATION_OWNERSHIP"
        }
      ],
      "kind": "ScalarField",
      "name": "viewerCan",
      "storageKey": "viewerCan(action:\"TRANSFER_ORGANIZATION_OWNERSHIP\")"
    },
    {
      "alias": "users",
      "args": null,
      "concreteType": "OrganizationUserConnection",
      "kind": "LinkedField",
      "name": "__OrganizationUsersFragment_users_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "OrganizationMembershipEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "OrganizationMembership",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v1/*:: as any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "kind",
                  "storageKey": null
                },
                {
                  "alias": "viewerCanDelete",
                  "args": [
                    {
                      "kind": "Literal",
                      "name": "action",
                      "value": "REMOVE_ORGANIZATION_MEMBER"
                    }
                  ],
                  "kind": "ScalarField",
                  "name": "viewerCan",
                  "storageKey": "viewerCan(action:\"REMOVE_ORGANIZATION_MEMBER\")"
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "User",
                  "kind": "LinkedField",
                  "name": "user",
                  "plural": false,
                  "selections": [
                    (v1/*:: as any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "username",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "displayName",
                      "storageKey": null
                    },
                    {
                      "args": [
                        {
                          "kind": "Literal",
                          "name": "thumbnail",
                          "value": true
                        }
                      ],
                      "kind": "FragmentSpread",
                      "name": "EntityProfilePicFragment"
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Organization",
  "abstractKey": null
};
})();

(node as any).hash = "a682d75b8489ba4836183aa2ae91b988";

export default node;
